import * as React from 'react';
import FreebusyStore from '../../../FreebusyStore';
import { observer } from 'mobx-react';
import ConfirmationModal from './ConfirmationModal';
import FreebusyProgramAdStore from './FreebusyProgramAdStore';
import AdDisplay from './AdDisplay';
import AdDisplayContent from './AdDisplayContent';

interface Props {
  freebusyStore: FreebusyStore;
  freebusyProgramAdStore: FreebusyProgramAdStore;
}

const AdDisplayStates: React.FC<Props> = ({ freebusyStore, freebusyProgramAdStore }) => {
  switch (freebusyStore.state.kind) {
    case 'waiting':
    case 'error':
      return <AdDisplayContent freebusyStore={freebusyStore} />;
    case 'initializing-store':
    case 'submitting':
    case 'loading':
    case 'initializing':
    case 'ready':
      return <AdDisplay freebusyStore={freebusyStore} />;
    case 'submitted':
      return (
        <>
          <AdDisplayContent freebusyStore={freebusyStore} />
          <ConfirmationModal
            eventDetails={freebusyStore.state.eventDetails}
            freebusyProgramAdStore={freebusyProgramAdStore}
          />
        </>
      );
  }
};

export default observer(AdDisplayStates);
